import { useState, useEffect } from "react";

import { objectField, requiredObjects } from "../utils/ObjectCreationData";
import { createCustomObject, createCustomObjectField, listCustomObjectFields, listCustomObjects } from "../service/custom_objects";


export const useSetup = () => {
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const setup = async () => {
      setLoading(true);

      try {
        const { custom_objects } = await listCustomObjects();
        const existingObjects = custom_objects.map((obj) => ({
          key: obj.key,
          title: obj.title,
        }));

        for (const required of requiredObjects) {
          const { label, value: objectKey } = required;

          const existingObj = existingObjects.find((o) => o.title === label);
          if (!existingObj) {
            const payload = {
              key: objectKey,
              title: label,
              title_pluralized: `${label}s`,
              description: `Objeto ${label}`,
            };

            await createCustomObject(payload);

            const requiredFields =
              objectField[objectKey as keyof typeof objectField] ?? [];

            for (const field of requiredFields) {
              await createCustomObjectField(objectKey, field);
            }

            continue;
          }
          const fieldResponse = await listCustomObjectFields(objectKey);
          const existingFields = fieldResponse.custom_object_fields ?? [];
          const existingFieldKeys = existingFields.map((f: any) => f.key);

          const requiredFields =
            objectField[objectKey as keyof typeof objectField] ?? [];

          for (const field of requiredFields) {
            const fieldExists = existingFieldKeys.includes(field.key);

            if (!fieldExists) {
              await createCustomObjectField(objectKey, field);
            }
          }
        }
      } catch (error) {
        console.error("Erro ao configurar objetos:", error);
      } finally {
        setLoading(false);
      }
    };

    setup();
  }, []);

  return { loading };
};
